module.exports = __webpack_public_path__ + "img/3-2.7af61268.svg";